import { gql } from '@apollo/client';

export interface ListSortingTagScanUnpublishableAreaIdsResponse {
    listSortingTagScanUnpublishableAreaIds: number[];
}

export interface ListSortingTagScanUnpublishableAreaIdsVariables {
    taskDate: string;
    warehouseId: number;
    areaIds: number[];
}

/**
 * 分拣贴号灰度场景：在传入的 areaIds 中筛选出"不可发布任务"的 areaId 列表。
 * 命中灰度配置 + 当前任务日下 dsp_task 已存在状态 ∈ {35,40,60,70,100}
 * （部分指派/已指派/规划中/已推送/已领取）的区域不允许再次发布任务。
 */
export const LIST_SORTING_TAG_SCAN_UNPUBLISHABLE_AREA_IDS = gql`
    query ListSortingTagScanUnpublishableAreaIds(
        $taskDate: LocalDate!
        $warehouseId: Long!
        $areaIds: [Long!]!
    ) {
        listSortingTagScanUnpublishableAreaIds(
            taskDate: $taskDate
            warehouseId: $warehouseId
            areaIds: $areaIds
        )
    }
`;
